<template>
  <v-container class="pa-7" fluid>
    <v-overlay :absolute="true" z-index="10" :value="overlayProcessing"><v-progress-circular color="swisetGreen" :size="70" width="5" indeterminate/></v-overlay>
    <h1 class="text-center">{{ $store.state.tournament.tournamentName }}</h1>
    <h3 class="text-center">{{ $t('header.creatorPrepend') }} {{ $store.state.tournament.tournamentOrganizer }}</h3>
    <v-row class="my-5" align="start" justify="center">
      <v-col cols="8">
        <TournamentStopped v-if="stoppedTournament"/>
        <Leaderboard v-else-if="started || finished"/>
        <!--Leaderboard v-if="$store.state.tournament.awards.length <= $store.state.tournament.participants.length && 3 <= $store.state.tournament.participants.length" :i-am-participant="meAsParticipant !== null"/-->
        <TournamentNotStarted v-else
                              @goToParticipants="overlayTournamentParticipants = true"
                              :i-am-participant="meAsParticipant !== null"/>
      </v-col>
      <v-col cols="4">
        <div v-if="adminUser" class="d-flex mb-7">
          <v-btn :disabled="new Date($store.state.tournament.startTime) < new Date()" class="button-settings" style="width: 49%" @click="tournamentSettings">
            {{ $t('btnSettings') }} <v-icon color="white" class="ml-2" small>fa-cog</v-icon>
          </v-btn>
          <v-btn class="button-settings ml-2" style="width: 49%" @click="tournamentParticipants">
            {{ $t('btnParticipants') }} <v-icon color="white" class="ml-2" small>fa-users</v-icon>
          </v-btn>
        </div>
        <UserSummary v-if="meAsParticipant != null" :participants="$store.state.tournament.participants" :participant-data="meAsParticipant"
                     :ranking-type="$store.state.tournament.rankingType" @seeDistribution="seeDistribution" @tournamentSettings="tournamentSettings"/>
        <h2 class="d-flex justify-center mb-9 black--text" v-else>{{ $t('notParticipant') }}
          <v-icon class="d-flex align-center justify-center ml-2" color="black">fa-grin-beam-sweat</v-icon>
        </h2>
        <TournamentAwards v-if="meAsParticipant == null"/>

        <!-- Additional Data !-->
        <TournamentTimer :start-date="new Date($store.state.tournament.startTime)" :end-date="new Date($store.state.tournament.endTime)"/>
        <p v-if="$store.state.tournament.imageUrl !== null" class="text-center mb-3 mt-n3" style="color: #3A3A3A">{{ $t('extraBox.creator') }}</p>
        <div v-if="$store.state.tournament.imageUrl !== null" class="d-flex justify-center"><v-img contain max-width="350px" max-height="70px" position="center center" :src="$store.state.tournament.imageUrl"/></div>
        <v-divider class="my-5"/>
        <a v-if="$store.state.tournament.faqsUrl !== null && $store.state.tournament.faqsUrl !== ''" :href="$store.state.tournament.faqsUrl" target="_blank" class="d-flex align-center justify-center">
          <v-icon :color="`#${$store.state.tournament.tournamentOrganizerColor}`" class="mr-3 mt-3" small>
            fa-question</v-icon><p :style="`color: #${$store.state.tournament.tournamentOrganizerColor}`" class="text-center mt-7">{{ $t('extraBox.FAQs') }}</p>
        </a>
        <a href="https://t.me/Swiset" target="_blank" class="d-flex align-center justify-center  mt-2">
          <v-icon :color="`#${$store.state.tournament.tournamentOrganizerColor}`" class="mr-3" small>
            fa-life-ring</v-icon><p :style="`color: #${$store.state.tournament.tournamentOrganizerColor}`" class="text-center mt-4">{{ $t('extraBox.help') }}</p>
        </a>
      </v-col>
    </v-row>

    <!-- Overlay Trades Distribution !-->
    <v-overlay v-model="overlayTradesDistribution">
      <TradesDistribution :broker-account="(meAsParticipant !== null)? meAsParticipant.brokerAccountId : 0" :from-date="$store.state.tournament.startTime" :faqs-url="$store.state.tournament.faqsUrl"
                          :to-date="$store.state.tournament.endTime" :paused="(meAsParticipant !== null)? meAsParticipant.status === 'PAUSED' : 'PAUSED'" @closeWindow="overlayTradesDistribution = false"/>
    </v-overlay>

    <!-- Overlay Tournament Settings !-->
    <v-overlay v-model="overlayTournamentSettings">
      <TournamentSettings :tournament-summary="$store.state.tournament" @closeWindow="overlayTournamentSettings = false"/>
    </v-overlay>

    <!-- Overlay Tournament Participants !-->
    <v-overlay v-model="overlayTournamentParticipants">
      <TournamentParticipants :tournament-summary="$store.state.tournament" @closeWindow="overlayTournamentParticipants = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex';
import Leaderboard from "@/views/Tournament/components/Leaderboard";
import Repository from '../../../repositories/tournament';
import UserSummary from "@/views/Tournament/components/UserSummary";
import TournamentTimer from "@/views/Tournament/components/TournamentTimer";
import TradesDistribution from "@/views/Tournament/components/TradesDistribution";
import VueConfetti from 'vue-confetti';
import TournamentSettings from "@/views/Tournament/components/TournamentSettings";
import TournamentParticipants from "@/views/Tournament/components/TournamentParticipants";
import TournamentNotStarted from "@/views/Tournament/components/TournamentNotStarted.vue";
import TournamentAwards from "@/views/Tournament/components/TournamentAwards";
import TournamentStopped from "@/views/Tournament/components/TournamentStopped.vue";

Vue.use(VueConfetti);

export default {
  name: "TournamentOverview",
  components: {
    TournamentStopped,
    TournamentAwards,
    TournamentNotStarted, TournamentParticipants, TournamentSettings, TradesDistribution, TournamentTimer, UserSummary, Leaderboard},
  props: {
    tournamentId: Number,
  },
  data() {
    return {
      overlayProcessing: false,
      started: false,
      finished: false,
      secsAutoRefresh: 0,
      adminUser: false,
      meAsParticipant: null,
      overlayTradesDistribution: false,
      overlayTournamentSettings: false,
      overlayTournamentParticipants: false,

      confettiOptions: {
        defaultColors: [
          'PaleGreen',
          'Gold',
          'lightblue',
        ],
        defaultDropRate: 6,
        defaultSize: 5,
        windSpeedMax: 0,
        particlesPerFrame: 1,
      },
    };
  },
  computed: {
    stoppedTournament() {
      return (this.started || this.finished) && this.$store.state.tournament.participants.length < 3;
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    this.$confetti.stop();
    let id = window.setTimeout(function() {}, 0); // Clearing existing timeouts
    while (id--)  window.clearTimeout(id);
  },
  watch: {
    '$store.state.tournament': function () {
      this.verifyMeAsParticipant();
    },
  },
  methods: {
    init() {
      this.overlayProcessing = true;

      // Verifying if refreshing
      if(this.tournamentId === undefined && this.$store.state.tournament === null)
        this.$router.push('/tournaments');

      this.getTournamentOverview();
    },
    getTournamentOverview() {
      let id = (this.tournamentId !== undefined)? this.tournamentId : this.$store.state.tournament.tournamentId;
      Repository.getTournamentOverview(id).then((response) => {
        if(response.status < 400) {
          this.overlayProcessing = false;
          this.computeTournamentBasics(response.data);
        }
      });
    },
    ...mapMutations(['setTournament']),
    computeTournamentBasics(tournamentOverview) {
      this.setTournament(tournamentOverview);
      let now = new Date();

      if(new Date(this.$store.state.tournament.endTime) < now) { // Ended tournament
        this.finished = true;
        this.$confetti.start(this.confettiOptions);
      }
      else if(new Date(this.$store.state.tournament.startTime) < now) {// Running tournament
        this.started = true;
        if (tournamentOverview.secsAutoRefresh !== null && tournamentOverview.secsAutoRefresh > 60) {
          this.secsAutoRefresh = tournamentOverview.secsAutoRefresh;
          // eslint-disable-next-line no-console
          console.log(`Calling tournament overview at: ${(new Date())}`);
          this.setTimerRealTimeEmulation();
        }
      }

      this.verifyMeAsParticipant();
      this.verifyIfAdmin();
    },
    verifyMeAsParticipant() {
      let foundParticipant = (this.identifier != null)?
          this.$store.state.tournament.participants.find(
              (participant) => participant.brokerAccountIdentifier === this.identifier) :
          this.$store.state.tournament.participants.find(
              (participant) => participant.userId === this.$store.state.user.id);

      this.meAsParticipant = (foundParticipant !== undefined)? foundParticipant : null;
    },
    verifyIfAdmin() {
      if(this.$store.state.tournament !== null && this.$store.state.clubMember !== null)
        this.adminUser = this.$store.state.tournament.tournamentOrganizerId === this.$store.state.clubMember.club.id &&
            (this.$store.state.clubMember.rol === 'FOUNDER') || (this.$store.state.clubMember.rol === 'ADMIN');
    },
    setTimerRealTimeEmulation() {
      setTimeout(this.getTournamentOverview, (this.secsAutoRefresh * 1000))
    },
    seeDistribution() {
      this.overlayTradesDistribution = true;
    },
    tournamentSettings() {
      this.overlayTournamentSettings = true;
    },
    tournamentParticipants() {
      this.overlayTournamentParticipants = true;
    }
  }
}
</script>

<i18n>
{
  "en": {
    "header": {
      "creatorPrepend": "Tournament organized by"
    },
    "btnSettings": "Settings",
    "btnParticipants": "Participants",
    "notParticipant": "You're not a participant",
    "extraBox": {
      "creator": "An amazing tournament brought to you by",
      "FAQs": "Tournament FAQs",
      "help": "Need help? Click here to talk with us."
    }
  },
  "es": {
    "header": {
      "creatorPrepend": "Torneo organizado por"
    },
    "btnSettings": "Ajustes",
    "btnParticipants": "Participantes",
    "notParticipant": "No estas participando",
    "extraBox": {
      "creator": "Un increíble torneo traído por parte de",
      "FAQs": "FAQs del Torneo",
      "help": "¿Necesita ayuda? Click aquí para hablar con nosotros."
    }
  }
}
</i18n>

<style scoped>
  .button-settings {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }
</style>
